import React, { useState, useEffect } from 'react'
import { Box, Grid, Button, Card, Chip, Typography, Avatar, TextField, Divider, IconButton } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { formatDate, getQuarterYear } from './DateFormate';
import DOMPurify from 'dompurify';
import { Announcement } from '@mui/icons-material';

const SinglePostCard = ({ feedPostData, handleClick, getCurrentMenu, formattedDate }) => {

  const [showFullContent, setShowFullContent] = useState(true);
  const toggleShowFullContent = () => {
    setShowFullContent(!showFullContent);
  };

  const sanitizedPostBody = DOMPurify.sanitize(feedPostData?.postBody);
  const words = sanitizedPostBody.split(' ');
  const maxWords = 20;
  const truncatedContent = words.slice(0, maxWords).join(' ');
  const showReadMore = words.length > maxWords;

  const feedPostConfig = {
    default: {
      name: (data) => data.userName ? data.userName : data.name,
      subtitle: (data) => '',
      headtitle: (data) => data.title,
      dateFormate: (data) => formattedDate,
      moreIcons: true,
    },
    notice: {
      name: (data) => data.userName ? data.userName : data.name,
      title: (data) => data.title,
      subtitle: (data) => '',
      dateFormate: (data) => formattedDate,
      moreIcons: true,
    },
    social: {
      name: (data) => data.userName ? data.userName : data.name,
      subtitle: (data) => '',
      dateFormate: (data) => formattedDate,
      moreIcons: true,
    },
    event: {
      name: (data) => data.userName ? data.userName : data.name,
      subtitle: (data) => '',
      title: (data) => data.title,
      dateFormate: (data) => formattedDate,
      moreIcons: true,
    },
    associate: {
      name: (data) => `${data.userName} ${data.middleName && data.middleName !== '--' ? data.middleName : ''} ${data.lastName ? data.lastName : ''}`,
      subtitle: (data) => data.designation,
      dateFormate: (data) => formattedDate,
      moreIcons: true,
    },
    leader: {
      name: (data) => `${data.userName} ${data.middleName && data.middleName !== '--' ? data.middleName : ''} ${data.lastName ? data.lastName : ''}`,
      subtitle: (data) => data.designation,
      dateFormate: (data) => formattedDate,
      headtitle: (data) => data.title,
      additionData: (data) => data.dateFormate,
      moreIcons: true,
    },
    birthday: {
      name: (data) => `Happy Birthday ${data.userName}`,
      subtitle: (data) => `Born On ${data.dateOfBirth ? data.dateOfBirth : ''}`,
      dateFormate: null,
      moreIcons: false,
    },
    child: {
      name: (data) => `Child of ${data.user?.userName || ''} ${data.user?.middleName || ''} ${data.user?.lastName || ''}`,
      subtitle: (data) => `Born on ${data.dateOfBirth}`,
      headtitle: (data) => data.childName,
      moreIcons: true,

    },
    userBirth: {
      name: (data) => `Happy Birthday ${data.userName}`,
      subtitle: (data) => `Born On ${data.dateOfBirth ? formatDate(data.dateOfBirth) : ''}`,
      moreIcons: false,
    },
    userWedding: {
      name: (data) => `${data.userName} With ${data.lastName}`,
      subtitle: (data) => `Married On-${data.weddingDate}`,
      moreIcons: false,
    },
    workAnniversary: {
      name: (data) => `Happy Work Anniversary ${data?.user?.userName || ''} ${data?.user?.middleName || ''} ${data?.user?.lastName|| ''}`,
      subtitle: (data) => `Completed-${data.totalWorkExperience} Years`,
      moreIcons: false,
    },
    userJoining: {
      name: (data) => `Welcome ${data.userName}`,
      subtitle: (data) => `Designation-${data.designation}`,
      moreIcons: true,
    },
    promotion: {
      name: (data) => `Congratulation ${data?.user?.userName || ''} ${data?.user?.middleName || ''} ${data?.user?.lastName || ''}`,
      subtitle: (data) => `Promoted as ${data.designation} on ${data.promotedDate}`,
      moreIcons: false,
    },
    accolade: {
      name: (data) => ``,
      subtitle: (data) => ``,
      additionData: (data) => data.dateFormate,
      moreIcons: true,
    },
    reward: {
      name: (data) => <Box sx={{ mt: 2 }}>
        <Typography fontWeight='var(--font-weight-4)' color="secondary.Heading2" variant='body2'>
          Awarded to <Typography component="span" sx={{ color: 'blue' }}>{data?.awardName}</Typography> on {data?.receivedDate}
        </Typography>
      </Box>,

      subtitle: (data) => '',
      title: (data) => <Chip label={getQuarterYear(new Date(data.created_at))} sx={{ backgroundColor: '#ED6C02', color: '#fff' }} />,
      moreIcons: true,
    },
  };

  const renderMoreIcons = (menus) => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton
          aria-label="more"
          id="long-button"
          onClick={(e) => handleClick(e, menus)}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
    )
  }

  const renderFeedPost = (data) => {
    const config = feedPostConfig[data.type] || feedPostConfig.default;

    return (
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={10} sm={10} md={10} lg={10} display='flex'>
            {(feedPostData.userName && feedPostData.type != 'userBirth' && feedPostData.type != 'userWedding' && feedPostData.type != 'workAnniversary' && feedPostData.type != 'promotion' && feedPostData.type != 'reward' && feedPostData.type != 'child' && feedPostData.type != 'userJoining') && (<Avatar
              src={feedPostData.userAvatar}
              alt={(feedPostData?.userName)}
              sx={{
                backgroundColor: 'transparent !Important',
                width: { xs: '45px', sm: '62px' },
                height: { xs: '45px', sm: '63px' },
                boxShadow: 'none',
                '& .MuiAvatar-img': {
                  height: { xs: '45px', sm: '63px' },
                  width: { xs: '45px', sm: '62px' },
                  textAlign: 'center',
                  objectFit: 'cover',
                  color: 'transparent',
                  textIndent: '10000px'
                }
              }} />)}
            <Box sx={{ ml: 2 }}>
              {config.title && (
                <Box>
                  <Typography variant='defineSubtitle2' color="primary.heading">
                    {config.title(data)}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex' }}>
                <Typography color="primary.heading" variant='defineSubtitle2'>
                  {config.name(data)}
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ mt: 1 }} variant="caption" color="secondary.Heading2">
                  {config.subtitle(data)}
                </Typography>
              </Box>

              {config.dateFormate && (
                <Box>
                  <Typography variant='Caption' color="secondary.Heading2">
                    {config.dateFormate(data)}
                  </Typography>
                </Box>
              )}

            </Box>
          </Grid>
          {config.moreIcons && (
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} key={"menu" + feedPostData.id}>
                {renderMoreIcons(getCurrentMenu(data))}
              </Box>
            </Grid>
          )}
        </Grid>
        {config.headtitle && (
          <Box sx={{ mt: 2 }}>
            <Typography variant='defineSubtitle2' color="primary.heading">
              {config.headtitle(data)}
            </Typography>
          </Box>
        )}
        <Box sx={{ mt: 2 }}>
          {
            config.additionData && (
              <Box>
                <Typography variant='defineSubtitle2' color="primary.heading">
                  {config.additionData(data)}
                </Typography>
              </Box>
            )
          }
        </Box>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={feedPostData.type === 'accolade' ? 10 : 12}>
              <Box>
                <Typography sx={{ mt: 1, wordBreak: 'break-word' }} color="secondary.Heading2" variant="body2" dangerouslySetInnerHTML={{ __html: showFullContent ? sanitizedPostBody : truncatedContent }} />
                {showReadMore && (
                  <Button onClick={toggleShowFullContent} sx={{ textTransform: 'unset !important' }}>
                    {showFullContent ? 'Read less' : 'Read more'}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {renderFeedPost(feedPostData)}
    </Box>

  )
}

export default SinglePostCard